import React from 'react';

export type StepperProps = {
	steps: string[];
	activeIndex: number;
};

const Stepper = ({ steps, activeIndex }: StepperProps) => (
	<div className="d-flex flex-column justify-content-start align-items-start" style={{ width: 'fit-content' }}>
		{steps.map((step, i) => {
			const isActive = i <= activeIndex;
			return (
				<React.Fragment key={step}>
					{i > 0 && (
						<div
							style={{
								width: 2,
								height: 42,
								backgroundColor: isActive
									? // '#06797F'
										'var(--np-primary-color)'
									: '#E3E7EB',
								marginLeft: 14,
							}}
						></div>
					)}
					<div className="d-flex flex-row gap-2">
						<div
							className="rounded-circle d-flex align-items-center justify-content-center fw-bold"
							style={{
								width: 30,
								height: 30,
								backgroundColor: isActive ? 'var(--np-primary-color)' : '#E3E7EB',
								color: isActive ? 'white' : '#4A5968',
							}}
						>
							{i + 1}
						</div>
						<span
							className={isActive ? 'fw-bold' : ''}
							style={{ color: isActive ? 'var(--np-text-primary-color)' : '#4A5968', textAlign: 'center', alignContent: 'center' }}
						>
							{step}
						</span>
					</div>
				</React.Fragment>
			);
		})}
	</div>
);

export default Stepper;
